export default __webpack_public_path__ + "static/3.4a26bb7c27b14c3013d8a4af18f5bffb.png";